module.exports = __webpack_public_path__ + "img/left-link-banner.69b89a22.png";